export default "__VITE_ASSET__DRS0VeJG__"